import { validRoutes, STICKY_MIN_YSCROLL } from '../constants';

/* eslint-disable no-useless-escape */
export const getUrlWithProtocol = (url) => {
  if (url && !/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = `http://${url}`;
  }
  return url;
};

export const getUrlHostname = (url) => {
  if (!url) {
    return '';
  }

  const urlWithProtocol = getUrlWithProtocol(url);
  let newUrl;

  try {
    newUrl = new URL(urlWithProtocol);
  } catch (_) {
    return urlWithProtocol;
  }

  return newUrl.hostname.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
};

export const scrollToHash = ({ hash }) => {
  if (hash) {
    const name = hash.replace('#', '');

    /* istanbul ignore else */
    if (name) {
      setTimeout(() => {
        const ele = document.querySelector(`*[name="${name}"]`);
        /* istanbul ignore else */
        if (ele) {
          let scrollValue = ele.getBoundingClientRect().top + window.pageYOffset;
          /* istanbul ignore else */
          if (
            window.pageYOffset < STICKY_MIN_YSCROLL &&
            scrollValue > STICKY_MIN_YSCROLL
          ) {
            /* istanbul ignore next */
            scrollValue = scrollValue - 2 * STICKY_MIN_YSCROLL;
          } else if (
            window.pageYOffset > STICKY_MIN_YSCROLL &&
            scrollValue > STICKY_MIN_YSCROLL
          ) {
            scrollValue = scrollValue - STICKY_MIN_YSCROLL;
          }
          window.scrollTo({ top: scrollValue, behavior: 'smooth' });
        }
      });
    }
  } else {
    setTimeout(() => {
      window.scrollTo({ top: 0 });
    });
  }
};

export const getBaseUrl = (pathname) => {
  let hasEndingSlash = false;
  let localPathname = pathname;

  // Strip out existing local route
  const lastItem = /\/\w+$/.exec(localPathname);
  if (lastItem && lastItem.length > 0 && validRoutes.includes(lastItem[0])) {
    localPathname = localPathname.replace(lastItem, '');
  }

  if (localPathname.length > 0) {
    hasEndingSlash = localPathname.lastIndexOf('/') === localPathname.length - 1;
  }

  return `${localPathname}${hasEndingSlash ? '' : '/'}`;
};

export const getGoogleMapUrl = (latitude, longitude) => {
  if (latitude && longitude) {
    return `http://google.com/maps/?q=${latitude},${longitude}`;
  }

  return null;
};
